import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home.js";
import Register from "../pages/Register.js";
import { Outlet, Navigate } from 'react-router-dom';
import authService from "../services/auth.service";
import Login from "../pages/Login.js";
import ListaAcoes from "../pages/ListaAcoes.js";
import Oportunidades from "../pages/Oportunidades.js";
import Favoritas from "../pages/Favoritas.js";
import ListaFIIs from "../pages/ListaFiis.js";
import FavoritosFiis from "../pages/FiisFavoritos.js";
import GlossarioAcoes from "../pages/GlossarioAcoes.js";
import GlossarioFiis from "../pages/GlossarioFiis.js";
import ExplicacaoML from "../pages/ExplicacaoML.js";
import Portfolio from "../pages/Portfolio.js";
import AcaoDetalhe from "../pages/AcaoDetalhe.js";
import FiiDetalhe from "../pages/FiiDetalhe.js";
import Admin from "../pages/Admin.js";
import Perfil from "../pages/Perfil.js";
import Comparar from "../pages/Comparar.js";
import Noticias from "../pages/Noticias.js";
import Guias from "../pages/Guias.js";
import GuiaDetalhe from "../pages/GuiaDetalhe.js";
import NaoEncontrada from "../pages/NaoEncontrada.js";

export const PrivateRoute = () => {
    const isAuthenticated = authService.isAuthenticated();

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}

const AdminRoute = () => {
    return authService.isAdmin() ? <Outlet /> : <Navigate to="/" />;
};

function Rotas() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/registrar" element={<Register />} />

            <Route path='/' element={<PrivateRoute />}>
                <Route index element={<Home />} />
                <Route path="/oportunidades" element={<Oportunidades />} />
                <Route path="/listaAcoes" element={<ListaAcoes />} />
                <Route path="/listaFiis" element={<ListaFIIs />} />
                <Route path="/favoritas" element={<Favoritas />} />
                <Route path="/favoritosFiis" element={<FavoritosFiis />} />
                <Route path="/glossario-acoes" element={<GlossarioAcoes />} />
                <Route path="/glossario-fiis" element={<GlossarioFiis />} />
                <Route path="/explicacao-ml" element={<ExplicacaoML />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/acao/:ticker" element={<AcaoDetalhe />} />
                <Route path="/fii/:ticker" element={<FiiDetalhe />} />
                <Route path="/perfil" element={<Perfil />} />
                <Route path="/comparar" element={<Comparar />} />
                <Route path="/noticias" element={<Noticias />} />
                <Route path="/guias" element={<Guias />} />
                <Route path="/guias/:slug" element={<GuiaDetalhe />} />
                <Route path="/admin" element={<AdminRoute />}>
                    <Route index element={<Admin />} />
                </Route>
            </Route>

            {/* Sem este curinga, endereço desconhecido não casava com nada e a
                tela ficava em branco entre o cabeçalho e o rodapé. */}
            <Route path="*" element={<NaoEncontrada />} />
        </Routes>
    );
}

export default Rotas;